/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ at: NonNullable<unknown> }} Ticket_Fe_Updated_AtInputs */

const en_ticket_fe_updated_at = /** @type {(inputs: Ticket_Fe_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.at}`)
};

const ja_ticket_fe_updated_at = /** @type {(inputs: Ticket_Fe_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新: ${i?.at}`)
};

const fr_ticket_fe_updated_at = /** @type {(inputs: Ticket_Fe_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mis à jour ${i?.at}`)
};

const de_ticket_fe_updated_at = /** @type {(inputs: Ticket_Fe_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisiert ${i?.at}`)
};

/**
* | output |
* | --- |
* | "Updated {at}" |
*
* @param {Ticket_Fe_Updated_AtInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_fe_updated_at = /** @type {((inputs: Ticket_Fe_Updated_AtInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Fe_Updated_AtInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_fe_updated_at(inputs)
	if (locale === "ja") return ja_ticket_fe_updated_at(inputs)
	if (locale === "fr") return fr_ticket_fe_updated_at(inputs)
	return de_ticket_fe_updated_at(inputs)
});